module.exports = __webpack_public_path__ + "static/media/screen-1.334ba7bd.png";